<template>
  <div class="container">
    <!-- 左侧布局 -->
    <div class="left-board">
      <el-scrollbar class="left-scrollbar">
        <div class="components-list">
          <draggable
            class="components-draggable"
            :list="componentList"
            :group="{ name: 'componentsGroup', pull: 'clone', put: false }"
            :clone="cloneComponent"
            draggable=".components-item"
            :sort="false"
            @end="onEnd"
          >
            <div v-for="(element, index) in componentList" :key="index" class="components-item">
              <div class="components-body">
                {{ element.name }}
              </div>
            </div>
          </draggable>
        </div>
      </el-scrollbar>
    </div>
    <!-- 中间布局 -->
    <div class="center-board">
      <div class="action-bar">
        <el-button class="copy-btn-main" icon="el-icon-success" type="text" @click="preview">
          预览
        </el-button>
        <el-button class="delete-btn" icon="el-icon-delete" type="text">
          清空
        </el-button>
      </div>
      <div id="ipad" ref="ipad">
        <div class="outeripad portrait">
          <div class="ipadbody">
            <div class="ipadscreen">
              <el-scrollbar class="center-scrollbar">
                <el-row class="center-board-row">
                  <el-form>
                    <draggable class="drawing-board" :list="widgetList" :animation="200" group="componentsGroup" @end="onMianDragEnd">
                      <el-col
                        v-for="(element, index) in widgetList"
                        :key="index"
                        class="drawing-item"
                        :class="{ 'active-from-item': activeIndex === index }"
                        :span="element.span"
                        @click.native.stop="selectItem(element, index)"
                      >
                        <render :item="element" />
                        <span class="drawing-item-delete" style="visibility:visibility;" title="删除" @click="delItem(element)">
                          <i class="el-icon-close" />
                        </span>
                      </el-col>
                      <!-- <draggable-item
                        v-for="(element, index) in widgetList"
                        :key="element.renderKey"
                        :element="element"
                        :drawing-list="widgetList"
                        :index="index"
                        :active-index="activeIndex"
                        @activeItem="itemActive"
                        @deleteItem="itemDelete"
                      ></draggable-item> -->
                    </draggable>
                    <div v-show="!widgetList.length" class="empty-info">
                      从左侧拖入或点选组件进行表单设计
                    </div>
                  </el-form>
                </el-row>
              </el-scrollbar>
            </div>
            <div class="ipadcamera" />
          </div>
        </div>
      </div>
    </div>
    <!-- 右侧配置项 -->
    <div class="right-board">
      <el-tabs v-model="currentTab" class="center-tabs">
        <el-tab-pane label="组件属性" name="field" />
        <el-tab-pane label="表单属性" name="form" />
      </el-tabs>
      <div class="field-box">
        <!-- 组件属性 -->
        <div>
          <el-form v-show="currentTab === 'field'" size="small" label-width="90px">
            {{ test }}
          </el-form>
        </div>

        <!-- 表单属性 -->
        <el-form v-show="currentTab === 'form'" size="small" label-width="90px" />
      </div>
    </div>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import DraggableItem from './components/DraggableItem.vue'
  import Render from './components/test.vue'
  export default {
    name: 'DialogForm',
    components: {
      draggable,
      Render,
      // DraggableItem,
      // WidgetForm
    },
    data() {
      return {
        currentTab: 'field',
        componentList: [
          {
            type: 'input',
            name: '文本框' + Math.floor(Math.random(10)),
            options: {
              width: '100%',
              defaultValue: '',
              placeholder: '123123123',
            },
            span: 24,
          },
          {
            type: 'textarea',
            name: '文本域' + Math.floor(Math.random(10)),
            options: {
              width: '100%',
              defaultValue: '',
              placeholder: '',
            },
            span: 12,
          },
        ],
        widgetList: [],
        test: '',
        activeIndex: null,
      }
    },
    methods: {
      //@ 深拷贝原有组件
      cloneComponent(origin) {
        const clone = JSON.parse(JSON.stringify(origin))
        clone.formId = Math.floor(Math.random(0, 10) * 100)
        // clone.span = formConf.span;
        clone.renderKey = clone.formId + new Date().getTime()
        return clone
      },
      //@ 拖拽结束事件
      onEnd({ newIndex, from, to }) {
        if (from !== to) {
          this.test = this.widgetList[newIndex].type
          this.activeIndex = newIndex
        }
      },
      //@ 中间部分拖拽事件结束
      onMianDragEnd({ newIndex }) {
        
        
        this.test = this.widgetList[newIndex].type
        this.activeIndex = newIndex
      },
      preview() {
        
      },
      itemActive(data, index) {
        this.activeIndex = index
        
      },
      itemDelete(data) {
        
      },
    },
  }
</script>
<style lang="scss" scoped>
  @import './styles/form.scss';
  #ipad {
    height: 100%;
    display: flex;

    .outeripad,
    .ipadbody,
    .ipadscreen {
      position: relative;
      height: 100%;
    }

    .ipadcamera,
    .ipadhomebutton {
      position: absolute;
    }
  }

  /* iPad */
  .outeripad {
    box-shadow: 0 0 13px 3px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
    margin: auto;

    &.portrait {
      padding: 45px 25px;
      height: 85% !important;
      width: 74%;
      min-height: 560px;
    }

    &.landscape {
      width: 90%;
      padding: 25px 45px;
      height: 78% !important;

      .ipadcamera {
        left: -20px;
        top: 50%;
        margin-top: -10px;
      }

      .ipadhomebutton {
        margin-right: -38px;
        top: 50%;
        right: 0;
        left: unset;
        margin-top: -18px;
      }
    }

    .ipadbody {
      background-color: white;
      border-radius: 10px;
    }

    .ipadscreen {
      background-color: rgba(239, 239, 239, 0.6);
    }

    .ipadcamera {
      top: -38px;
      left: 50%;
      background-color: #aeaeae;
      height: 10px;
      width: 10px;
      border-radius: 5px;
      margin-top: 10px;
      margin-left: -5px;
    }

    .ipadhomebutton {
      background-color: #fff;
      height: 30px;
      width: 30px;
      border-radius: 15px;
      border: 1px solid #a8a8a8;
      margin-top: 6px;
      margin-left: -15px;
      left: 50%;
      cursor: pointer;
    }

    .el-radio-group {
      line-height: 2.5;
    }
  }
  .el-date-editor .el-range-separator {
    box-sizing: content-box;
  }
  .right-board {
    border-left: 1px solid #f1e8e8;
    width: 350px;
    position: absolute;
    right: 0;
    top: 0;
    padding-top: 3px;

    .field-box {
      position: relative;
      height: calc(100vh - 200px);
      box-sizing: border-box;
      overflow-x: hidden;
    }

    .el-scrollbar {
      height: calc(100% - 48px);
    }
  }

  .select-item {
    display: flex;
    border: 1px dashed #fff;
    box-sizing: border-box;

    & .close-btn {
      cursor: pointer;
      color: #f56c6c;
    }

    & .el-input + .el-input {
      margin-left: 4px;
    }
  }

  .select-item + .select-item {
    margin-top: 4px;
  }

  .select-item.sortable-chosen {
    border: 1px dashed #409eff;
  }

  .select-line-icon {
    line-height: 32px;
    font-size: 22px;
    padding: 0 4px;
    color: #777;
  }

  .option-drag {
    cursor: move;
  }

  .time-range {
    .el-date-editor {
      width: 227px;
    }

    ::v-deep .el-icon-time {
      display: none;
    }
  }

  .document-link {
    position: absolute;
    display: block;
    width: 26px;
    height: 26px;
    top: 0;
    left: 0;
    cursor: pointer;
    background: #409eff;
    z-index: 1;
    border-radius: 0 0 6px 0;
    text-align: center;
    line-height: 26px;
    color: #fff;
    font-size: 18px;
  }

  .node-label {
    font-size: 14px;
  }

  .node-icon {
    color: #bebfc3;
  }

  .calc-btn {
    padding: 4px 8px;
    margin: 0 6px;
    background: #e5e5e5;
    cursor: pointer;
    &.error {
      background: #f56c6c;
      color: white;
    }
    &:hover {
      background: #f5f5f5;
    }
  }

  .pane-calc-preview {
    padding: 0 10px;
    cursor: pointer;
    min-height: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    font-size: 12px;
  }
  .calc-dialog {
    >>> .el-dialog__body {
      padding-top: 0;
    }
    .calc-box {
      font-size: 12px;
      line-height: 2;
      .calc-tip {
        margin: 10px 0;
        font-size: 12px;
        color: #aaa;
      }

      .calc-preview {
        border: 1px solid #e5e5e5;
        border-radius: 4px;
        min-height: 60px;
        padding: 4px 10px;
        position: relative;

        &.error {
          border: 1px solid red;
        }

        .preview-actions {
          position: absolute;
          bottom: 0;
          right: 0;
          > i {
            font-size: 14px;
            margin-right: 8px;
            cursor: pointer;
            &:hover {
              color: red;
            }
          }
        }
      }
    }
  }
</style>
